import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ResponseDto } from '@models/exceptions/response-dto';
import { finalize, Observable } from 'rxjs';
import { BaseService } from '../base-service';
import { FormBase } from '@models/portal/users/form-base';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';

@Injectable({
  providedIn: 'root',
})
export class RodadasService extends BaseService {
  url = this.envUrl + '/v1/rodadas';

  constructor() {
    super();
  }

  buscarRodadaPorId(rodNrId: number): Observable<ResponseDto<RodadaDto>> {
    return this.http.get<ResponseDto<RodadaDto>>(`${this.url}/${rodNrId}`);
  }

  buscarRodadasPorEtapa(petNrId: number): Observable<ResponseDto<RodadaDto[]>> {
    return this.http.get<ResponseDto<RodadaDto[]>>(
      `${this.url}/etapas/${petNrId}`,
    );
  }

  buscarRodadaPorEtapaEOrdem(
    petNrId: number,
    rodNrOrdemExecucao: number,
  ): Observable<ResponseDto<RodadaDto>> {
    return this.http.get<ResponseDto<RodadaDto>>(
      `${this.url}/etapas/${petNrId}/ordem/${rodNrOrdemExecucao}`,
    );
  }

  deletarRodadaEReordenar(
    rodNrId: number,
    petNrId: number,
  ): Observable<ResponseDto<void>> {
    return this.http.delete<ResponseDto<void>>(
      `${this.url}/${rodNrId}/etapas/${petNrId}`,
    );
  }
}

export interface RodadaDto {
  rodNrId: number;
  rodTxNome: string;
  rodDtInicio: string;
  rodDtFim: string;
  rodNrOrdemExecucao: number;
  rodTxTipoRodada: TipoRodadaEnum | null;
}

export class RodadaForm extends FormBase {
  rodTxNome: string;
  rodTxTipoRodada: TipoRodadaEnum | null;
  rodNrOrdemExecucao: number;
  rodDtInicio: string;
  rodDtFim: string;

  constructor(dto?: RodadaDto) {
    super();
    this.rodTxNome = dto?.rodTxNome || '';
    this.rodTxTipoRodada = dto?.rodTxTipoRodada || null;
    this.rodNrOrdemExecucao = dto?.rodNrOrdemExecucao || 0;
    this.rodDtInicio = dto?.rodDtInicio || '';
    this.rodDtFim = dto?.rodDtFim || '';
    this.entNrId = dto?.rodNrId;
    this.entTxMetadado = dto ? MetadataPutEnum.INALTERADO : MetadataPutEnum.CRIADO;
  }
}
export enum TipoRodadaEnum {
  Classificatoria = 'CLASSIFICATORIA',
  FaseGrupos = 'FASE_GRUPOS',
  Eliminatoria = 'ELIMINATORIA',
  Semifinal = 'SEMIFINAL',
  Final = 'FINAL',
}
